module.exports = __webpack_public_path__ + "static/media/ceiling-spraying.b1bb7948.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/optimised/ceiling-spraying.jpg
// module id = 85
// module chunks = 0